<template>
    <div>
        <div class="text-h5 font-weight-bold pl-3">
            {{ inputGroup.title }}
        </div>
        <p class="text-subtitle-2 text-medium-emphasis pl-3">
            <CalcTextContainer>
                {{ inputGroup.description }}
            </CalcTextContainer>
        </p>
        <InputGroup :inputs="inputGroup.inputs" />
    </div>
</template>
<script setup>
import CalcInput from './CalcInput.vue'
import CalcInputContainer from './CalcInputContainer.vue'
import CalcTextContainer from './CalcTextContainer.vue'
import InputGroup from './InputGroup.vue'

defineProps({
    inputGroup: { type: Object },
})
</script>
